import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import BusinessSelectionWizard from '../../Reusable/BusinessSelectionWizard';
import { getClientById } from '../../../Service';
import { setStylistUserData } from '../../../reducers/User/action';

// Shown after login when the professional isn't yet associated with a business (getCheckBusiness check).
export default function StylistSelectBusiness() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const stylistUser = useSelector(store => store.user['stylistuser']);
    const stylistLogoutUrl = useSelector(store => store.user.stylistLogoutUrl);

    const goToNextPage = () => {
        if (stylistUser.userType === 'Old User') {
            if (stylistLogoutUrl === undefined || stylistLogoutUrl === null) {
                navigate('/stylist/dashboard');
            } else {
                navigate(stylistLogoutUrl);
            }
        } else if (stylistUser.userType === 'New User') {
            navigate('/stylist/step-I');
        }
    };

    const proceedAfterLogin = () => {
        // stylistUser.shopId is stale (it was empty at login time, before the business was associated)
        // refresh the profile so downstream pages (e.g. step-I's slot booking) have the real shopId
        getClientById({ clientId: stylistUser.clientId }).then((res) => {
            if (res.data && res.data.shopId) {
                dispatch(setStylistUserData({ ...stylistUser, shopId: res.data.shopId, shopName: res.data.shopName }));
            }
        }).catch(() => {}).finally(() => {
            goToNextPage();
        });
    };

    return (
        <BusinessSelectionWizard
            clientId={stylistUser ? stylistUser.clientId : ''}
            professionalFirstName={stylistUser ? stylistUser.firstName : ''}
            professionalLastName={stylistUser ? stylistUser.lastName : ''}
            professionalPhoneNumber={stylistUser ? stylistUser.phoneNumber : ''}
            onSaved={proceedAfterLogin}
        />
    );
}
